/**
 * ShopeePay icon URL
 * Shopee's integrated e-wallet payment solution popular across Southeast Asia
 * Source: Airwallex documentation
 * Used for payment method selection UI
 */
export const SHOPEEPAY_ICON_DATA_URL =
  'https://www.airwallex.com/docs/assets/contentful/images.ctfassets.net/c3n7jozh84hr/1BYCLeHNQEyPXBjlIdu09h/71d67c5be3975f77091bf45c7ab58f65/ShopeePay.svg';
